import { render, staticRenderFns } from "./coverageManage.vue?vue&type=template&id=ecf376b4&scoped=true&"
import script from "./coverageManage.vue?vue&type=script&lang=js&"
export * from "./coverageManage.vue?vue&type=script&lang=js&"
import style0 from "./coverageManage.vue?vue&type=style&index=0&id=ecf376b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf376b4",
  null
  
)

export default component.exports